import { render, staticRenderFns } from "./OurPrograms.vue?vue&type=template&id=69c2a583&scoped=true&"
import script from "./OurPrograms.vue?vue&type=script&lang=js&"
export * from "./OurPrograms.vue?vue&type=script&lang=js&"
import style0 from "./OurPrograms.vue?vue&type=style&index=0&id=69c2a583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c2a583",
  null
  
)

export default component.exports